import { api } from 'boot/axios.js'

export async function download(ctx, data) {
  try {
    const response = await api({
      url: '/quotes/download',
      method: 'POST',
      data: data,
      responseType: 'arraybuffer'
    })
    return response
  } catch (e) {
    return e
  }
}
